import {
  Folder,
  Image,
  Video,
  Music,
  Presentation,
  FileSpreadsheet,
  FileText,
  File,
  Code,
  Database,
  Archive,
  Zap,
  type LucideIcon,
} from 'lucide-react';

import { fileIconStyle, type FileIconInput, type FileIconKind } from './file-icon-kind';

/**
 * The lucide glyph per icon kind. Two kinds intentionally share a glyph but
 * differ in colour: `word`/`text` both use `FileText`, `pdf`/`file` both use
 * `File` — the colour comes from {@link fileIconStyle}.
 */
const ICON_BY_KIND: Record<FileIconKind, LucideIcon> = {
  folder: Folder,
  image: Image,
  video: Video,
  audio: Music,
  presentation: Presentation,
  spreadsheet: FileSpreadsheet,
  word: FileText,
  pdf: File,
  code: Code,
  database: Database,
  archive: Archive,
  executable: Zap,
  text: FileText,
  file: File,
};

/** The small type-coloured glyph shown beside a file/folder name in the table. */
export function FileTypeIcon({ file, size = 16 }: { file: FileIconInput; size?: number }) {
  const { kind, color } = fileIconStyle(file);
  const Icon = ICON_BY_KIND[kind];
  return <Icon size={size} color={color} />;
}
